import React from 'react';

import InternReferrals from '.';

const PhysicianReferrals = () => {
  return <InternReferrals kind="physician" />;
};

export default PhysicianReferrals;
